import { render, staticRenderFns } from "./SetFecha.vue?vue&type=template&id=3ec4d854"
import script from "./SetFecha.vue?vue&type=script&lang=ts"
export * from "./SetFecha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports